import { webapi } from "$/utils/webapi";

export interface AddressItem {
  id: string;
  level?: number;
  parent?: string;
  name: string;
  postcode?: string;
  address?: string;
  spell?: string;
}

export interface GeoResultItem {
  current: AddressItem;
  children?: AddressItem[];
  parents?: AddressItem[];
}

export const fetchGeoData = async (
  residenceCountry: string,
  id?: string,
): Promise<GeoResultItem> => {
  return await webapi.getRaw(
    `https://geo.easit.cc/${residenceCountry}${id ? `/${id}` : ""}`,
    {},
  );
};

export const fetchGeoDataByPostCode = async (
  residenceCountry: string,
  postCode: string,
) =>
  await webapi.getRaw<GeoResultItem[]>(
    `https://geo.easit.cc/search_postcode/${residenceCountry}/${postCode}`,
    {},
  );
